import { Loading } from '@/features/loading/Loading'
import { useFlowStore } from '@/store/flowStore'
import { createFileRoute, redirect } from '@tanstack/react-router'

function CarregandoPage() {
  return <Loading redirectTo="/resultado" />
}

export const Route = createFileRoute('/carregando')({
  component: CarregandoPage,
  beforeLoad: () => {
    const { completed, steps, index } = useFlowStore.getState()
    const hasCompletedFlow = completed || (steps.length > 0 && index >= steps.length)
    if (!hasCompletedFlow) {
      throw redirect({ to: '/objetivo' })
    }
  },
})
